module.exports = __webpack_public_path__ + "static/media/bg-home-waves-alt-3x.4ea3aa26.png";